import { useMutation } from "@tanstack/react-query";
import { createSessionDocument } from "../services/create-document";
import { useToast } from "@/hooks/use-toast";
import { ToastAction } from "@/components/ui/toast";

export function useCreateDocument() {
  const { toast } = useToast();

  return useMutation({
    mutationFn: (sessionId: string) => createSessionDocument(sessionId),
    onMutate: () => {
      toast({
        title: "Creating document...",
        description: "This may take a few seconds.",
      });
    },
    onSuccess: (data) => {
      toast({
        title: "Document created successfully",
        action: (
          <ToastAction
            altText="Open document"
            onClick={() => window.open(data.documentUrl, "_blank")}
          >
            Open
          </ToastAction>
        ),
      });
    },
    onError: (error) => {
      toast({
        title: "Failed to create document",
        description: error.message || "Something went wrong.",
        variant: "destructive",
      });
    },
  });
} 